export default __webpack_public_path__ + "static/media/3.9872d292.jpeg";